import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Box, Divider, HStack, Icon, Text, VStack, useTheme } from "native-base";
import React, { useState } from "react";
import Accordion from "react-native-collapsible/Accordion";

import { HELP_CENTRAL_MESSAGES } from "@/config/messages";

const HelpContainer = () => {
  const { colors } = useTheme();
  const [activeSessions, setActiveSessions] = useState({});
  return (
    <VStack>
      {Object.values(HELP_CENTRAL_MESSAGES).map((session) => (
        <VStack
          key={session.sessionTitle}
          m="1"
          p="2"
          py="4"
          bgColor="white.50"
          shadow="4"
          rounded="md">
          <Box>
            <Text py="2" fontSize="lg" bold>
              {session.sessionTitle}
            </Text>
          </Box>
          <Accordion
            sections={session.sessionData}
            activeSections={activeSessions[session.sessionTitle] || []}
            renderHeader={(session) => (
              <Box>
                <HStack justifyContent="space-between" alignItems="center">
                  <Text flexGrow={1} flexBasis={1} py="3" color="primary.600">
                    {session.title}
                  </Text>
                  <Icon
                    as={<MaterialCommunityIcons name="chevron-down" />}
                    size="md"
                    color="primary.600"
                  />
                </HStack>
                <Divider />
              </Box>
            )}
            renderContent={(session) => (
              <Box py="2">
                <Text>{session.message}</Text>
              </Box>
            )}
            onChange={(active) =>
              setActiveSessions((prev) => ({ ...prev, [session.sessionTitle]: active }))
            }
            underlayColor={colors.gray[200]}
          />
        </VStack>
      ))}
    </VStack>
  );
};

export default HelpContainer;
